export default __webpack_public_path__ + "static/media/Close-green.7d32f722.svg";